import React, { Component } from "react";


export class SimplePdfViewer extends React.Component {
    render() {
        
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%"
                }}
            >
                <object
                    data={this.props.url}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                >
                    <p>
                        Impossible d'afficher le PDF.
                        <a href={this.props.url} target="_blank" rel="noreferrer">
                            Ouvrir le PDF
                        </a>
                    </p>
                </object>
            </div>
        );
    }
}